'use strict';

import './vendor/jquery.formstyler';

const apply = () => {
    if ($('.select-s').length > 0) {
        $('.select-s').styler({
            selectSmartPositioning: false,
            selectSearch: true,
            locale: LOCALE_STYLER,
        });
    }
};

apply();

export {apply};
